import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY


export const getUnitsGrouped = (setUnits, tipoIds = []) => {
    const params = new URLSearchParams();
    if (tipoIds.length > 0) {
        tipoIds.forEach(id => params.append('tipoIds', id.toString()));
    }

    const url = `${urlApi}/direccion/unitsGrouped${params.toString() ? `?${params.toString()}` : ''}`;

    api.get(url)
        .then((res) => {
            setUnits(res.data);
        })
        .catch((error) => {
            console.log("error", error);
        });
}

export const getTypeUnits = (setTypeUnits) => {
    api.get(`${urlApi}/direccion/typeUnits`).then((res) => {
        setTypeUnits(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getPercent = (setPercent, tipoIds = []) => {
    const params = new URLSearchParams();
    if (tipoIds.length > 0) {
        tipoIds.forEach(id => params.append('tipoIds', id.toString()));
    }

    const url = `${urlApi}/direccion/unitsPercent${params.toString() ? `?${params.toString()}` : ''}`;

    api.get(url)
        .then((res) => {
            const negativeStatusIds = [1];
            const updatedData = res.data.map((item) => {
                const isNegativeStatus = negativeStatusIds.includes(item.ID_STATUS) && item.PRESUPUESTO > item.UNIDADES;
                const isLessThanBudget = item.PRESUPUESTO < item.UNIDADES;
                const isPositive = (isNegativeStatus || isLessThanBudget) ? false : item.PORCENTAJE > 0;

                return {
                    ...item,
                    isPositive
                };
            });
            setPercent(updatedData);
        })
        .catch((error) => {
            console.log("error", error);
        });
};

export const getIdleUnits = (setIdleUnits, tipoIds = []) => {
    const params = new URLSearchParams();
    if (tipoIds.length > 0) {
        tipoIds.forEach(id => params.append('tipoIds', id.toString()));
    }
    const url = `${urlApi}/direccion/idleUnits${params.toString() ? `?${params.toString()}` : ''}`;


    api.get(url).then((res) => {
        setIdleUnits(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const updateBudget = async (id, budget) => {
    try {
        await api.put(`${urlApi}/direccion/updateBudget`, {
            id, budget
        });
    } catch (err) {
        console.log("error", err);
    }
}
